import { useNavigate } from "react-router-dom";
import { useMenu } from "../context/MenuContext"; // 🧩 Access global menu close handler
// 🧩 Use scroll Link for navigator, it will helps handling animation smooth
export const ScrollLink = ({ section, className, children }) => {
  const navigate = useNavigate();
  const { closeMenu } = useMenu();

  const handleClick = (e) => {
    e.preventDefault();

    // 🧩 Close mobile menu immediately on click
    closeMenu();

    // 🧩 Delay route change slightly to allow close animation
    setTimeout(() => {
      if (window.location.pathname !== "/") {
        // 🧩 Navigate to homepage if not already there
        navigate("/");

        // 🧩 Scroll after route + DOM updates
        setTimeout(() => {
          const target = document.getElementById(section);
          if (target) {
            target.scrollIntoView({ behavior: "smooth" });
          }
        }, 400); // 🧩 Adjust if transition duration differs
      } else {
        // 🧩 Already on homepage — scroll immediately
        const target = document.getElementById(section);
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 100); // 🧩 Delay to sync with menu close animation
  };

  return (
    <span onClick={handleClick} className={className} role="link" tabIndex={0}>
      {children}
    </span>
  );
};
